import { NOTIFICATIONS_APP_NAME } from "Shared/Types/notifications";
import {
  CONTACTS,
  EQUIPMENTS,
  FUEL_HISTORY,
  INSPECTIONS_HISTORY,
  ISSUES,
  PARTS,
  PURCHASE_ORDERS,
  REMINDERS_SERVICES,
  REPORTS,
  SERVICE_HISTORY,
  SETTINGS_GENERAL_SETTING_BILLING,
  UNITS,
  VENDORS,
  WORK_ORDERS,
} from "./routes";

export const NOTIFICATIONS_ROUTE: Record<NOTIFICATIONS_APP_NAME, string> = {
  [NOTIFICATIONS_APP_NAME.Parts]: PARTS,
  [NOTIFICATIONS_APP_NAME.Contacts]: CONTACTS,
  [NOTIFICATIONS_APP_NAME.Inspection]: INSPECTIONS_HISTORY,
  [NOTIFICATIONS_APP_NAME.Fuel]: FUEL_HISTORY,
  [NOTIFICATIONS_APP_NAME.Vehicles]: UNITS,
  [NOTIFICATIONS_APP_NAME.Work_orders]: WORK_ORDERS,
  [NOTIFICATIONS_APP_NAME.Purchase_order]: PURCHASE_ORDERS,
  [NOTIFICATIONS_APP_NAME.Reports]: REPORTS,
  [NOTIFICATIONS_APP_NAME.Reminders]: REMINDERS_SERVICES,
  [NOTIFICATIONS_APP_NAME.Issues]: ISSUES,
  [NOTIFICATIONS_APP_NAME.Billing]: SETTINGS_GENERAL_SETTING_BILLING,
  [NOTIFICATIONS_APP_NAME.Service_entry]: SERVICE_HISTORY,
  [NOTIFICATIONS_APP_NAME.Inventory]: EQUIPMENTS,
  [NOTIFICATIONS_APP_NAME.Vendors]: VENDORS,
};
